import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthGuardCrypto } from './pages-crypto/auth-crypto/auth-guard-crypto.service';
import { ForgotPasswordMessageCryptoComponent } from './pages-crypto/components-crypto/forgot-password-message-crypto/forgot-password-message-crypto.component';
import { RegistrationMessageCryptoComponent } from './pages-crypto/components-crypto/registration-message-crypto/registration-message-crypto.component';
import { ResetPasswordMessageCryptoComponent } from './pages-crypto/components-crypto/reset-password-message-crypto/reset-password-message-crypto.component';

const routes: Routes = [
  {
    path: 'pages',
    // OAuth2 Security - https://akveo.github.io/nebular/#/docs/auth/protecting-application-routes
    canActivate: [AuthGuardCrypto], // here we tell Angular to check the access with our AuthGuardCrypto
    // loadChildren: 'app/pages/pages.module#PagesModule'
    loadChildren: 'app/pages-crypto/pages-crypto.module#PagesCryptoModule',
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
      {
        path: 'forgot-password-message',
        component: ForgotPasswordMessageCryptoComponent,
      },
      {
        path: 'reset-password-message',
        component: ResetPasswordMessageCryptoComponent,
      },
      {
        path: 'registration-message',
        component: RegistrationMessageCryptoComponent,
      },
    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts